import React, { useState } from 'react';
import { ContactUsButton } from './ContactUsButton';
import { ContactUsModal } from './ContactUsModal';
import './ContactUs.scss';

export const ContactUs: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <ContactUsButton onClick={openModal} />
      <ContactUsModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default ContactUs;


